import { useNavigate } from "react-router-dom";
import { T } from "../tokens";
import { useEffect } from "react";

function ArrowRight({ size = 20, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M9 6l6 6-6 6" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function ListIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M4 6h16M4 12h16M4 18h16" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function ButterflyIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M 11.8491 9.1962 L 8.2135 6.5549 c -0.7837 -0.5694 -1.7241 -0.6771 -2.5331 -0.0894 C 5.5376 6.5695 5.3725 6.7133 5.2538 6.8766 c -0.8817 1.2135 0.0759 4.9994 1.2894 5.8811 c 0.7319 0.5318 1.542 0.7082 2.5231 0.553 c -0.4199 0.1218 -0.7802 0.3397 -1.0822 0.6538 c -1.0811 1.1169 -1.4845 2.1352 -0.9919 2.8129 C 7.4705 17.4355 8.1266 18.2343 8.5311 18.5282 c 1.2135 0.8817 3.3542 -1.7803 3.3179 -3.1668 L 11.8491 9.1962 z m 1.1314 0 L 16.616 6.555 C 17.3999 5.9854 18.3402 5.8779 19.1492 6.4656 c 0.1431 0.104 0.3082 0.2478 0.4269 0.4109 c 0.8815 1.2137 -0.076 4.9995 -1.2897 5.8811 c -0.7319 0.532 -1.5418 0.7084 -2.5228 0.5531 c 0.4195 0.1217 0.7802 0.3398 1.0819 0.654 c 1.0812 1.117 1.4845 2.135 0.9921 2.8128 c -0.4783 0.6583 -1.1342 1.4569 -1.5389 1.7508 c -1.2134 0.8817 -3.3544 -1.78 -3.3178 -3.1669 l -0.0003 -6.1651 z" 
      stroke={color} strokeWidth="1.5" strokeLinecap="round"/>
    </svg>
  );
}

function SettingsIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke={color} strokeWidth="1.8" />
      <path d="M 18.4 13 a 7.5 7.5 0 0 0 0 -2 l 1.7 -1.3 l -2 -3.4 l -2 0.8 a 7.5 7.5 0 0 0 -1.7 -1 L 14 4 h -4 l -0.4 2.1 a 7.5 7.5 0 0 0 -1.7 1 l -2 -0.8 l -2 3.4 L 5.6 11 a 7.5 7.5 0 0 0 0 2 l -1.7 1.3 l 2 3.4 l 2 -0.8 a 7.5 7.5 0 0 0 1.7 1 L 10 20 h 4 l 0.4 -2.1 a 7.5 7.5 0 0 0 1.7 -1 l 2 0.8 l 2 -3.4 L 18.4 13 z" stroke={color} strokeWidth="1.6" strokeLinejoin="round" />
    </svg>
  );
}

function ExportIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 3v13M7 11l5 5 5-5" stroke={color} strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M3 21h18" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

function ShieldIcon({ size = 22, color = 'currentColor' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6l8-3z" stroke={color} strokeWidth="1.8" strokeLinejoin="round" />
    </svg>
  );
}

export default function MainMenu() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  const firstName = user?.firstName || "Surveyor";
  const initials = (user?.firstName?.[0] || 'S') + (user?.lastName?.[0] || '');

  const logout = () => {
    localStorage.clear();
    navigate("/");
  };

  const now = new Date();
  const dateStr = now.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' });
  const hour = now.getHours();
  const greeting = hour < 12 ? 'Good morning' : hour < 17 ? 'Good afternoon' : 'Good evening';

  const tile = (title, sub, icon, iconBg, action) => (
    <button onClick={action} style={{
      width: '100%', textAlign: 'left', padding: 18, borderRadius: T.r.lg,
      background: T.card, border: `1px solid ${T.line}`, cursor: 'pointer',
      display: 'flex', gap: 14, alignItems: 'center',
    }}>
      <div style={{
        width: 48, height: 48, borderRadius: T.r.md, background: iconBg,
        color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
      }}>{icon}</div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontFamily: T.fontDisplay, fontSize: 17, fontWeight: 600, color: T.ink, letterSpacing: '-0.01em' }}>{title}</div>
        <div style={{ fontFamily: T.font, fontSize: 13, color: T.ink2, marginTop: 2 }}>{sub}</div>
      </div>
      <span style={{ color: T.ink3 }}><ArrowRight size={20} /></span>
    </button>
  );

  useEffect(() => {
    if(localStorage.getItem("user") == null) {
      logout();
    }
  }, [])

  return (
    <div className="lep-page">
      <div className="lep-page-inner" style={{ padding: '54px 20px 48px' }}>
        {/* Greeting */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24 }}>
          <div>
            <div style={{ fontFamily: T.font, fontSize: 13, color: T.ink2 }}>{dateStr}</div>
            <div style={{ fontFamily: T.fontDisplay, fontSize: 28, fontWeight: 600, color: T.ink, letterSpacing: '-0.025em', marginTop: 2 }}>
              {greeting}, {firstName}
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button onClick={logout} style={{
              height: 36, padding: '0 14px', borderRadius: T.r.pill, border: `1px solid ${T.line}`,
              background: T.card, color: T.ink, fontFamily: T.font, fontSize: 13, fontWeight: 600,
              cursor: 'pointer', whiteSpace: 'nowrap',
            }}>Logout</button>
            <div style={{
              width: 44, height: 44, borderRadius: 9999, background: T.forestSoft,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              color: T.forest, fontFamily: T.font, fontWeight: 700, fontSize: 16,
              textTransform: 'uppercase',
            }}>{initials}</div>
          </div>
        </div>

        {/* Hero CTA */}
        <button onClick={() => navigate("/survey")} style={{
          width: '100%', textAlign: 'left', padding: '22px 22px',
          borderRadius: T.r.xl, background: T.forest, color: '#fff',
          border: 'none', cursor: 'pointer', position: 'relative', overflow: 'hidden',
          display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between',
          minHeight: 168, boxShadow: '0 12px 32px rgba(45,80,22,0.22)',
        }}>
          <div style={{ position: 'absolute', right: -20, top: -10, opacity: 0.18 }}>
            <ButterflyIcon size={180} color="#F5F1E8" />
          </div>
          <div style={{ position: 'relative' }}>
            <div style={{ fontFamily: T.font, fontSize: 12, fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', opacity: 0.7 }}>Start now</div>
            <div style={{ fontFamily: T.fontSerif, fontSize: 30, fontWeight: 500, marginTop: 6, letterSpacing: '-0.01em' }}>Begin a survey</div>
            <div style={{ fontFamily: T.font, fontSize: 14, opacity: 0.85, marginTop: 6 }}>Pollard, meandering, or incidental</div>
          </div>
          <div style={{
            position: 'relative', width: 48, height: 48, borderRadius: 9999,
            background: 'rgba(255,255,255,0.18)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0,
          }}>
            <ArrowRight size={22} color="#fff" />
          </div>
        </button>

        {/* Nav tiles */}
        <div style={{ fontFamily: T.font, fontSize: 12, fontWeight: 600, color: T.ink2, letterSpacing: '0.08em', textTransform: 'uppercase', margin: '24px 4px 10px' }}>More</div>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {tile('Recent surveys', 'View and manage past surveys', <ListIcon size={22} />, T.forest, () => navigate("/surveys"))}
          {tile('Favorites', 'Select butterflies to favorite', <ButterflyIcon size={25} />, T.forest, () => navigate("/favorites"))}
          {tile('Export data', 'Download as CSV or JSON', <ExportIcon size={22} />, T.honey, () => navigate("/export"))}
          {tile('Settings', 'Defaults, units, sections', <SettingsIcon size={22} />, T.honey, () => navigate("/settings"))}
          {tile('Admin', 'Manage species library', <ShieldIcon size={22} />, '#3F4440', () => navigate("/admin"))}
        </div>
      </div>
    </div>
  );
}
